<template>
  <div id="app">
    <el-container>
      <el-header><global-nav></global-nav></el-header>
        <router-view/>
      <el-footer><footer-nav></footer-nav></el-footer>
    </el-container>
  </div>
</template>

<script>
import GlobalNav from './components/02-organisms/GlobalNav.vue'
import FooterNav from './components/02-organisms/FooterNav.vue'
export default {
  name: 'eden',
  components: {
    'global-nav': GlobalNav,
    'footer-nav': FooterNav
  },
  created: function () {
    console.log('created:App')
  }
}
</script>

<style>
html,body{
  font-family:arial, sans-serif;
}
body{
  margin:0;
}
.el-header, .el-footer{
  padding:0;
}
.el-menu--horizontal{
  z-index: 1;
}
/*.el-main{
  border-top:solid 1px #e6e6e6;
  border-bottom:solid 1px #e6e6e6;
}*/
/*#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}*/
</style>



// WEBPACK FOOTER //
// src/App.vue